import { ApiResponse } from './../models/ApiResponse';
import { Alert } from "./../models/Alert";
import { SystemConfig } from "./../models/SystemConfig";
import { SUSPENDED, AUTHENTICATED_USER, LOGIN_MESSAGE_ACCOUNT_SUSPENDED, ACTIVE, OBS_IS_UNDER_MAINTENANCE, LIFE_CORP_TEL_NO, BANNED, AUTHENTICATED_USER_PASSWORD, LOGIN_ACCOUNT_NAME } from "./../app.constant";
import { SystemDataService } from "./../service/data/system-data.service";
import { BasicAuthenticationService } from "./../auth/basic-authentication.service";
import { Component, OnInit, ɵConsole } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { IN_MAINTENANCE_MODE, IN_OPERATION_MODE, MAIN_ACCOUNT_ID } from "../app.constant";
import { Account } from "../models/account";

@Component({
  selector: "app-login-form",
  templateUrl: "./login-form.component.html",
  styleUrls: ["./login-form.component.css"]
})
export class LoginFormComponent implements OnInit {
  //#region Alert bar

  alertsOnPopUpPanel: Alert[] = [];

  //#endregion

  form: FormGroup;

  private formSubmitAttempt: boolean;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private basicAuthenticationService: BasicAuthenticationService,
    private systemDataService: SystemDataService
  ) { }

  async ngOnInit() {

    this.account = new Account("123123", "", "", "", "", "", "", new Date(), "", "", 1, "", "", 1, 1, 1, new Date(), "", new Date(), "");

    this.basicAuthenticationService.clearSession();

    var response = await this.systemDataService.getSystemConfig(OBS_IS_UNDER_MAINTENANCE).toPromise<ApiResponse<SystemConfig>>();

    if (response.OK != null) {

      var systemConfig = response.OK;

      if (systemConfig.value == IN_OPERATION_MODE) {
//if system in operation mode, do nothing?
      } 
      else if (systemConfig.value == IN_MAINTENANCE_MODE) {

        this.basicAuthenticationService.clearSession();

        this.router.navigate(["maintenance"]);

      }
    } else if (response.ERROR != null) {

      this.updateAlertArray(response.ERROR, false);

    }

    this.form = this.fb.group({
      // {5}
      userName: ["", [Validators.required]],
      password: ["", Validators.required]
      //userName: ["M001", [Validators.required]],
      //password: ["1234", Validators.required]
    });
  }

  isFieldInvalid(field: string) {
    // {6}
    return (
      (!this.form.get(field).valid && this.form.get(field).touched) ||
      (this.form.get(field).untouched && this.formSubmitAttempt)
    );
  }

  updateAlertArray(msg: string, success: boolean) {
    if (success) {
      this.alertsOnPopUpPanel = Array.from([{ type: "success", message: msg }]);
    } else {
      this.alertsOnPopUpPanel = Array.from([{ type: "danger", message: msg }]);
    }
    setTimeout(() => (this.alertsOnPopUpPanel = []), 5000);
  }

  account: Account;

  showSuspendedMessage: boolean = false;

  lifeCorpHotline: string = "00000000";

  async handleLogin() {


    if (this.form.value.userName != "" && this.form.value.password != "") {

      var response = await this.basicAuthenticationService.executeObsAuthenticationService(this.form.value.userName, this.form.value.password).toPromise<ApiResponse<Account>>();

      if (response.OK != null) {

        this.account = response.OK;

        if (this.account.status.toUpperCase() == SUSPENDED) {

          this.showSuspendedMessage = true;

          this.basicAuthenticationService.logout();

          var systemConfig = await this.systemDataService.getSystemConfig(LIFE_CORP_TEL_NO).toPromise<ApiResponse<SystemConfig>>();

          if (systemConfig.OK!=null) {
            this.lifeCorpHotline = systemConfig.OK.value;
          }

        } else
          if (this.account.status.toUpperCase() == ACTIVE || this.account.status.toUpperCase() == BANNED) {

            sessionStorage.setItem(LOGIN_ACCOUNT_NAME, this.account.fullName);

            sessionStorage.setItem(MAIN_ACCOUNT_ID, this.account.mainAccountId);

            sessionStorage.setItem(AUTHENTICATED_USER, this.account.accountId);

            sessionStorage.setItem(AUTHENTICATED_USER_PASSWORD, this.form.value.password);

            this.router.navigate(["dashboard"]);
          }

      } else if (response.ERROR!=null) {

        console.log("error message " + response.ERROR);

        this.updateAlertArray(response.ERROR, false);
      }
    }
  }

  resetPassword() {
    this.router.navigate(["resetPassword"]);
  }
}
